import type { ServerCart } from 'components/molecules/Goods/utils';

export type CheckoutCartOrder = ServerCart['orders'][number];
type CheckoutOrder = CheckoutCartOrder;

export const resolveCheckoutCartOrder = (
  serverCart?: ServerCart | null,
  orderId?: string | number
): CheckoutOrder | undefined => {
  const orders = serverCart?.orders ?? [];
  if (!orders.length) return undefined;

  if (orderId === undefined || orderId === null || orderId === '') {
    return orders[0];
  }

  const locationId = Number(orderId);
  if (Number.isFinite(locationId)) {
    const matched = orders.find(order => order.locationId === locationId || order.id === locationId);
    if (matched) return matched;
  }

  return orders[0];
};
